<div class="container m-0 p-0">
  <div class="row">
    <div class="col dialog-title">New Position</div>
  </div>
  <div class="row">
    <div class="col dialog-content">
      <div [formGroup]="form">
        <div class="modal__item row">
          <label
            class="label-input col-4"
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'department'"
            [touched]="form.get('department')!.touched"
            >Department
          </label>
          <div class="col-8 modal-validation">
            <app-dropdown
              [items]="departmentItems"
              formControlName="department"
            ></app-dropdown>
            <app-error-field
              [displayError]="isFieldInvalid('department', form)"
              [errorMessage]="'The field is required'"
            ></app-error-field>
          </div>
        </div>
        <div class="modal__item row" *ngIf="isSubDepartment">
          <label
            class="label-input col-4"
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'subDepartment'"
            [touched]="form.get('subDepartment')!.touched"
            >Sub department
          </label>
          <div class="col-8 modal-validation">
            <app-dropdown
              [items]="subDepartmentItems"
              formControlName="subDepartment"
            ></app-dropdown>
            <app-error-field
              [displayError]="isFieldInvalid('subDepartment', form)"
              [errorMessage]="'The field is required'"
            ></app-error-field>
          </div>
        </div>
        <div class="modal__item row">
          <label
            class="label-input col-4"
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'positionName'"
            [touched]="form.get('positionName')!.touched"
            >Name
          </label>
          <div class="col-8 modal-validation">
            <input
              type="text"
              class="input__basic"
              placeholder=" "
              formControlName="positionName"
            />
            <app-error-field
              [displayError]="
                isFieldInvalid('positionName', form) &&
                form.get('positionName')!.hasError('required')
              "
              [errorMessage]="'The field is required'"
            ></app-error-field>
            <app-error-field
              [displayError]="form.get('positionName')!.hasError('maxlength')"
              [errorMessage]="'Max field length = 30'"
            ></app-error-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row align-items-center justify-content-end dialog-buttons">
    <div class="col-auto p-0 mb-3">
      <button class="button button__save add-margin" (click)="saveData()">
        Save
      </button>
      <button class="button button__cancel" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
